<template>
	<div class="breadcrumb">
		<el-breadcrumb separator="/">
		  <el-breadcrumb-item v-for="item in matched" :to="{path:item.path}">{{item.meta.title}}</el-breadcrumb-item>
		</el-breadcrumb>
	</div>
</template>

<script>
	export default {
		name: 'Breadcrumb',
		components: {
			
		},
		data() {
			return {
				matched: []
			}
		},
		watch: {
			$route(to, from) {
				this.matched = this.$route.matched
			}
		},
		created(){
			console.log('bread')
			console.log(this.$route)
			this.matched = this.$route.matched
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.breadcrumb{
		margin-bottom: 10px;
	}
</style>